<template>
	<div class="switch-ctr">
		<div class="switch" @click="toggleStatus" :class="{ on: isActive }"></div>
		<span class="description" v-if="description">{{description}}</span>
	</div>
</template>
<script>
	export default {
		name: 'uSwitch',
		props: {
			status: {
				type: Boolean,
				default: false
			},
			onChange: {
				type: Function,
				default() {},
			},
			description: {
				type: String
			}
		},
		data() {
			return {
				isActive: this.status
			}
		},
		methods: {
			toggleStatus() {
				this.isActive = !this.isActive
				this.$emit('toggle', this.isActive)
				this.onChange(this.on);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/uSwitch/uSwitch.vue